module.exports = __webpack_public_path__ + "static/media/send.eb3526cb.svg";